var exports = {
  "NQ": "xe564cbfb--ab9a34--features-list",
  "aZ": "xe564cbfb--ab9a34--feature-title",
  "Fn": "xe564cbfb--ab9a34--feature-item",
};

module.exports = exports;
